@if (product$ | async; as product) {
  <div class="cx-general-product-info">
    <cx-configurator-exit-button></cx-configurator-exit-button>
    <div class="cx-title">
      <span> {{ product.name }} </span>
    </div>
    <button (click)="triggerDetails()" [attr.aria-expanded]="showMore">
      @if (!showMore) {
        <div class="cx-toggle-details-link-text">
          <span aria-hidden="true">{{ 'configurator.header.showMore' | cxTranslate }}</span>
        </div>
        <cx-icon
          [attr.aria-label]="
            'configurator.a11y.showMoreProductInfo' | cxTranslate: { product: product.name }
          "
          [type]="iconTypes.CARET_DOWN"
        ></cx-icon>
      }
      @if (showMore) {
        <div class="cx-toggle-details-link-text" aria-hidden="true">
          {{ 'configurator.header.showLess' | cxTranslate }}
        </div>
        <cx-icon
          [attr.aria-label]="
            'configurator.a11y.showLessProductInfo' | cxTranslate: { product: product.name }
          "
          [type]="iconTypes.CARET_UP"
        ></cx-icon>
      }
    </button>
    <div class="cx-details" [class.open]="showMore">
      <div class="cx-details-image" aria-hidden="true">
        <cx-media [container]="product?.images?.['PRIMARY']" format="product"></cx-media>
      </div>
      <div class="cx-details-content" [attr.aria-hidden]="showMore ? false : true">
        <div class="cx-detail-title">
          @if (product.name) {
            <span [attr.title]="'configurator.a11y.productName' | cxTranslate">
              {{ product.name }}
            </span>
          }
        </div>
        <div class="cx-code">
          @if (product.code) {
            <span [attr.title]="'configurator.a11y.productCode' | cxTranslate">
              {{ product.code }}
            </span>
          }
        </div>
        <div class="cx-description">
          @if (product.description) {
            <span
              [attr.title]="'configurator.a11y.productDescription' | cxTranslate"
              >
              {{ product.description }}
            </span>
          }
        </div>
        @if (expMode | async) {
          @if (configuration$ | async; as configuration) {
            @if (configuration.kbKey) {
              <div class="cx-kb-key-details">
                @if (configuration.kbKey.kbName) {
                  <div class="cx-kb-pair">
                    <span
                      class="cx-label"
                      [attr.aria-label]="
                        'configurator.a11y.kbKeyName'
                          | cxTranslate: { name: configuration.kbKey.kbName }
                      "
                      >
                      {{ 'configurator.header.kbKeyName' | cxTranslate }}
                    </span>
                    <span class="cx-value">
                      {{ configuration.kbKey.kbName }}
                    </span>
                  </div>
                }
                @if (configuration.kbKey.kbLogsys) {
                  <div class="cx-kb-pair">
                    <span
                      class="cx-label"
                      [attr.aria-label]="
                        'configurator.a11y.kbKeyLogsys'
                          | cxTranslate: { logsys: configuration.kbKey.kbLogsys }
                      "
                      >
                      {{ 'configurator.header.kbKeyLogsys' | cxTranslate }}
                    </span>
                    <span class="cx-value">
                      {{ configuration.kbKey.kbLogsys }}
                    </span>
                  </div>
                }
                @if (configuration.kbKey.kbVersion) {
                  <div class="cx-kb-pair">
                    <span
                      class="cx-label"
                      [attr.aria-label]="
                        'configurator.a11y.kbKeyVersion'
                          | cxTranslate: { version: configuration.kbKey.kbVersion }
                      "
                      >
                      {{ 'configurator.header.kbKeyVersion' | cxTranslate }}
                    </span>
                    <span class="cx-value">
                      {{ configuration.kbKey.kbVersion }}
                    </span>
                  </div>
                }
                @if (configuration.kbKey.kbBuildNumber) {
                  <div class="cx-kb-pair">
                    <span
                      class="cx-label"
                      [attr.aria-label]="
                        'configurator.a11y.kbKeyBuildNr'
                          | cxTranslate: { number: configuration.kbKey.kbBuildNumber }
                      "
                      >
                      {{ 'configurator.header.kbKeyBuildNr' | cxTranslate }}
                    </span>
                    <span class="cx-value">
                      {{ configuration.kbKey.kbBuildNumber }}
                    </span>
                  </div>
                }
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
} @else {
  <div class="cx-ghost-general-product-info"></div>
}
